export abstract class Component {
  public abstract el: HTMLElement;

  show() {
    this.el.style.display = '';
  }

  hide() {
    this.el.style.display = 'none';
  }

  toggle() {
    if (this.el.style.display === 'none') {
      this.show();
    } else {
      this.hide();
    }
  }

  center() {
    const rect = this.el.getBoundingClientRect();
    this.el.style.position = 'absolute';
    this.el.style.left = `${Math.floor(window.innerWidth / 2 - rect.width / 2)}px`;
    this.el.style.top = `${Math.floor(window.innerHeight / 2 - rect.height / 2)}px`;
  }
}
